import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TableResponsiveWidthPipe } from './table-responsive-width.pipe';
import { StaticTableWidthPipe } from './static-table-width.pipe';
import { DynamicColumnPipe } from './dynamic-column-width.pipe';
import { StaticColumnPipe } from './static-column-width.pipe';
import { FirstStaticColumnPipe } from './first-static-column-width.pipe';
import { FirstStaticColumnTitlePipe } from './first-static-column-title-width.pipe';

@NgModule({
  declarations: [
    TableResponsiveWidthPipe,
    StaticTableWidthPipe,
    DynamicColumnPipe,
    StaticColumnPipe,
    FirstStaticColumnPipe,
    FirstStaticColumnTitlePipe,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    TableResponsiveWidthPipe,
    StaticTableWidthPipe,
    DynamicColumnPipe,
    StaticColumnPipe,
    FirstStaticColumnPipe,
    FirstStaticColumnTitlePipe,
  ],
})
export class CatalogItemsPipesModule {}
